import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

export function useCanViewOrganizationActivityLog(): boolean {
    return useCanPerformOrganizationAction(
        OrganizationAction.VIEW_ORGANIZATION_ACTIVITY_LOG,
    );
}
